// extracted by mini-css-extract-plugin
module.exports = {"learnWrapper":"Learn_learnWrapper__s4Y8Z","learn":"Learn_learn__l25lp","actionCard":"Learn_actionCard__Ve8xr","image":"Learn_image__iDJiv"};